import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "city"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "city-map"
}, null, -1);
const _hoisted_3 = {
  class: "city-main-wrap"
};
const _hoisted_4 = {
  class: "city-search-form"
};
const _hoisted_5 = {
  class: "city-search-input"
};
const _hoisted_6 = {
  class: "city-list"
};
const _hoisted_7 = {
  key: 0,
  class: "loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_index_anchor = _resolveComponent("van-index-anchor");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_index_bar = _resolveComponent("van-index-bar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_nav_bar, {
    class: "city-nav-bar",
    border: false,
    title: $setup.title
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
    class: "input",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.cityKeyword = $event),
    type: "text",
    placeholder: "请输入城市名称",
    onInput: _cache[1] || (_cache[1] = (...args) => $options.getDistrictSearch && $options.getDistrictSearch(...args))
  }, null, 544), [[_vModelText, $setup.cityKeyword]])]), _createElementVNode("div", {
    class: "cancel-btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goBack && $options.goBack(...args))
  }, "取消")]), _createElementVNode("div", _hoisted_6, [!$setup.filterData || $setup.filterData.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_van_loading, {
    size: "40px",
    color: "#ff9500",
    "text-color": "#777",
    vertical: ""
  }, {
    default: _withCtx(() => [_createTextVNode(" 正在查询... ")]),
    _: 1
  })])) : _createCommentVNode("", true), $setup.filterData && $setup.filterData.length > 0 ? (_openBlock(), _createBlock(_component_van_index_bar, {
    key: 1,
    "highlight-color": "#ff9500"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterData, (item, listIndex) => {
      return _openBlock(), _createElementBlock("div", {
        key: item.letter
      }, [_createVNode(_component_van_index_anchor, {
        index: item.letter
      }, null, 8, ["index"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (row, itemIndex) => {
        return _openBlock(), _createBlock(_component_van_cell, {
          key: row.id,
          title: row.name,
          onClick: $event => $options.selectCity(listIndex, itemIndex)
        }, null, 8, ["title", "onClick"]);
      }), 128))]);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true)])])]);
}